var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9345_21665)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 26.5,
    r: 26.5,
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0667 37.0999C11.0667 33.1249 16.3667 33.1249 19.0167 30.4749C20.3417 29.1499 16.3667 29.1499 16.3667 22.5249C16.3667 18.1087 18.1329 15.8999 21.6667 15.8999C25.2004 15.8999 26.9667 18.1087 26.9667 22.5249C26.9667 29.1499 22.9917 29.1499 24.3167 30.4749C26.9667 33.1249 32.2667 33.1249 32.2667 37.0999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4998 33.5666C31.5015 32.8762 31.9185 32.8087 33.1628 32.2094C34.1356 31.7408 35.0742 31.2097 35.8091 30.4749C37.1341 29.1499 33.1591 29.1499 33.1591 22.5249C33.1591 18.1087 34.9253 15.8999 38.4591 15.8999C41.9928 15.8999 43.7591 18.1087 43.7591 22.5249C43.7591 29.1499 39.7841 29.1499 41.1091 30.4749C43.7591 33.1249 49.0591 33.1249 49.0591 37.0999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9345_21665",
    x: 0,
    y: 0,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9345_21665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9345_21665",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsersIcon);
export default __webpack_public_path__ + "static/media/manage-users-icon.e0d806710ec1348043aabcf7a037e94b.svg";
export { ForwardRef as ReactComponent };